var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5064 12.5938H5.58984V37.0297H44.5064V12.5938Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3056 31.4862H13.7929C13.7929 31.0925 13.7153 30.7027 13.5647 30.3389C13.414 29.9752 13.1932 29.6447 12.9148 29.3663C12.6364 29.0879 12.3059 28.8671 11.9422 28.7165C11.5785 28.5658 11.1886 28.4883 10.7949 28.4883V20.9086C11.59 20.9086 12.3526 20.5927 12.9148 20.0305C13.477 19.4683 13.7929 18.7057 13.7929 17.9106H36.3056C36.3056 18.7057 36.6215 19.4683 37.1837 20.0305C37.7459 20.5927 38.5085 20.9086 39.3036 20.9086V28.4883C38.9099 28.4883 38.52 28.5658 38.1563 28.7165C37.7926 28.8671 37.4621 29.0879 37.1837 29.3663C36.9053 29.6447 36.6845 29.9752 36.5338 30.3389C36.3832 30.7027 36.3056 31.0925 36.3056 31.4862Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.049 27.3435C26.7598 27.3435 28.1467 25.9566 28.1467 24.2457C28.1467 22.5349 26.7598 21.1479 25.049 21.1479C23.3381 21.1479 21.9512 22.5349 21.9512 24.2457C21.9512 25.9566 23.3381 27.3435 25.049 27.3435Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0488 35.4062V46.6811",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9434 45.085L25.0488 45.9795L27.1542 45.085L25.0488 50.0761L22.9434 45.085Z",
    fill: "#20448B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0488 -4.0752V10.5939",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg10);
export default __webpack_public_path__ + "static/media/Website icons SVG-10.c292a0e3624c7a5c478532cb267aafe8.svg";
export { ForwardRef as ReactComponent };